/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceConfigId } from "../../commons/types/SpaceConfigId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { WorkbookId } from "../../commons/types/WorkbookId";
import { SpaceSettings } from "./SpaceSettings";
import { Action } from "../../commons/types/Action";
import { SpaceAccess } from "./SpaceAccess";
import { AppId } from "../../commons/types/AppId";
export const InternalSpaceConfigBase = core.serialization.object({
    spaceConfigId: SpaceConfigId.optional(),
    environmentId: EnvironmentId.optional(),
    primaryWorkbookId: WorkbookId.optional(),
    metadata: core.serialization.any().optional(),
    settings: SpaceSettings.optional(),
    actions: core.serialization.list(Action).optional(),
    access: core.serialization.list(SpaceAccess).optional(),
    autoConfigure: core.serialization.boolean().optional(),
    namespace: core.serialization.string().optional(),
    labels: core.serialization.list(core.serialization.string()).optional(),
    translationsPath: core.serialization.string().optional(),
    languageOverride: core.serialization.string().optional(),
    archivedAt: core.serialization.date().optional(),
    appId: AppId.optional(),
    isAppTemplate: core.serialization.boolean().optional(),
});
